/**
 * 📝 **신청 폼 주소를 엣지가 받는 모양으로** — 랠리 완주 선물 신청 폼(2026-10-21).
 *
 * 엣지는 `https://` 로 시작하는 주소만 받고 나머지는 **조용히 버린다**(apps/edge/src/rally.ts sanitizeEventOverride).
 * 운영자는 주소창에서 `forms.gle/…` 만 복사해 붙이는 일이 흔한데, 그러면 주소가 빠진 채 「✅ 웹에 올렸어요」가 떴다 —
 * 완주한 아이에게 신청 단추가 안 뜬다(로컬에서 운영자 할 일을 걸어 보다 찾음).
 * 여기서 흔한 모양을 고쳐 보내고, 그래도 서버가 안 받았으면 화면이 실패로 말한다(RallyEventPanel).
 */
export function normalizeFormUrl(raw: string): string {
  const s = raw.trim();
  if (!s) return "";
  if (/^https:\/\//i.test(s)) return s;
  // 폼 서비스(구글·네이버)는 https 로도 열린다 — http 로 붙여도 같은 곳이다
  if (/^http:\/\//i.test(s)) return `https://${s.slice(7)}`;
  // 「forms.gle/abc」·「naver.me/abc」처럼 앞이 빠진 주소(점이 있고 공백이 없으면 주소로 본다)
  if (!/\s/.test(s) && /^[\w-]+(\.[\w-]+)+(\/|$)/.test(s)) return `https://${s}`;
  return s; // 고칠 수 없는 모양 — 그대로 보내고 서버 답으로 판정한다
}
